module.exports = __webpack_public_path__ + "static/EmilyIsAway2-f3f2ed27ccf5d2ea7f1fa396b3bf97d2.png";